export var isTextTrackEqual=function(a,l){return void 0!==l&&a.kind===l.kind&&a.lang===l.lang&&a.label===l.label};